export default "__VITE_ASSET__BgUUUXqe__"